import { COMPLIANCE_SETTINGS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/compliance_settings_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

// Singleton per buyer org — the record lives in `detail` via fetchOneSuccess.
const initialState: any = standardInitialStateGenerator([]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
